import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import defaultPic from '../assets/images/user_icon.png';
import { useInAppNotificationStore } from '../store/useInAppNotificationStore';
import { useNavigate } from 'react-router-dom';
import { getSizedImageUrl } from '../utils/getSizedImageUrl';

interface NotificationsProps {
  show: boolean;
  handleClose: () => void;
  userId: string;
}

const Notifications: React.FC<NotificationsProps> = ({ show, handleClose, userId }) => {
  const [activeTab, setActiveTab] = useState<'unread' | 'read'>('unread');
const navigate = useNavigate();
  const {
    notifications,
    loading,
    getNotifications,
    markSeenNotification
  } = useInAppNotificationStore();
  const [resolvedImages, setResolvedImages] = useState<string[]>([]);



  useEffect(() => {
    console.log(activeTab);
    if (show) {
      getNotifications({
        userId,
        page: 0,
        limit: 20,
        isRead: activeTab == 'read',
      });
    }
  }, [show, activeTab, userId, getNotifications]);

  const filteredNotifications = notifications;

 

useEffect(() => {
  const resolveImageUrls = async () => {
    const promises = filteredNotifications.map(async (notification) => {
      // Try user profile image first
      if (notification.user?.profile_image) return getSizedImageUrl(notification.user.profile_image, '150x150');

      // Then try sized thumbnail
      const sizedUrl = await getSizedImageUrl(notification.user_photos_to?.[0]?.picture, '150x150');
      return sizedUrl || defaultPic; // Fallback to default
    });

    const result = await Promise.all(promises);
    setResolvedImages(result);
  };

  resolveImageUrls();
}, [filteredNotifications]);

  return (
    <Modal className="offcanvas offcanvas-end bg-light" show={show} onHide={()=>{handleClose(); setActiveTab('unread');}}>
      <div className="offcanvas-header">
            <div className="pb-2 d-flex align-items-center w-100">
                <h4 className="mb-0">Notifications center</h4>
                <button type="button" className="btn-close" onClick={()=>{handleClose(); setActiveTab('unread');}} data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
        </div>
   

      <div className="offcanvas-body px-3 py-2">
        <ul className="notification_btn_tabs nav nav-pills mb-3" id="pills-tab" role="tablist">
                  <li className="nav-item" role="presentation">
                      <button className="nav-link active" id="pills-unread-tab" data-bs-toggle="pill"
                          data-bs-target="#pills-unread" type="button" role="tab" aria-controls="pills-unread"
                          aria-selected="true" onClick={() => setActiveTab('unread')}>
                          Unread
                      </button>
                  </li>
                  <li className="nav-item" role="presentation">
                      <button className="nav-link" id="pills-read-tab" data-bs-toggle="pill" data-bs-target="#pills-read"
                          type="button" role="tab" aria-controls="pills-read" aria-selected="false" onClick={() => setActiveTab('read')}>
                          Read
                      </button>
                  </li>
              </ul>
        
            
        <div className="notification_items_wrapper">

        {loading ? (
          <div className="text-center py-4">Loading...</div>
        ) : filteredNotifications.length === 0 ? (
          <div className="text-center py-4">No {activeTab} notifications</div>
        ) : (
        
          <>
           {filteredNotifications.map((notification, index) => {
             const imageSrc = resolvedImages[index] || defaultPic;
             
              let route = '';
              let messageText = notification.message;

              switch (notification.type) {
                case 'request':
                  route = '/liked';
                  break;
                case 'match':
                  route = '/matched';
                  break;
                case 'priority':
                  route = `/messages/${notification.request_id}`;
                   const name = notification.user?.name ?? '';
                  const capitalizedName = name.charAt(0).toUpperCase() + name.slice(1);
                  messageText = `${capitalizedName} ${notification.message}`;
                  break;
                  case 'message':
                    route = `/messages/${notification.request_id}`;
                   
                  break;
                default:
                  return null; // Skip unknown types
              }

              return (
                <div key={notification.id} 
                  className="notification_item d-flex justify-content-between align-items-center"
                  onClick={() => {
                     markSeenNotification({userId:notification.receiver_id,type:notification.type});
                    navigate(route);
                    handleClose();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center">
                    <div className="notification_item_img me-3">
                      <img
                        src={imageSrc}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                    <p className="mb-0">{messageText}</p>
                  </div>
                  <i className="fa-solid fa-chevron-right text-muted"></i>
                </div>
              );
            })}

           </>
        )}
       </div>
      </div>
    </Modal>
  );
};

export default Notifications;
